import styled from '@emotion/styled';
import { ButtonBase } from '@material-ui/core';
import { createElement, FC } from 'react';

import { SPACING_LARGE } from '../../../constant/spacing';
import { gridLayoutContainer } from '../../../styleUtility/gridLayout';

interface Props {
  onClick: () => void;
  className?: string;
}

export const FormatSelector: FC<Props> = ({ children, onClick, className }) => {
  return (
    <FormatSelectorRoot component={'div'} onClick={onClick} className={className}>
      {children}
    </FormatSelectorRoot>
  );
};

const FormatSelectorRoot = (styled(ButtonBase)(
  gridLayoutContainer({
    columns: ['100%'],
    rows: ['auto', 'auto'],
    areas: [['icon'], ['description']],
    alignItems: 'center',
    justifyItems: 'center',
  }),
  {
    width: '100%',
    height: '100%',
    padding: `${SPACING_LARGE}px 0`,
    cursor: 'pointer',
  },
) as unknown) as typeof ButtonBase;
